export enum Permission {
  StoreInterventionsView = 'store_interventions.view',
  StoreInterventionsModify = 'store_interventions.modify',
  StoreInterventionsCreateNewRequest = 'store_interventions.create_new_request',
  StoreInterventionsAssignRequest = 'store_interventions.assign_request',
  PartnersV4View = 'partners_v4.view',
}
